import { Product } from '../types'

export const products: Product[] = [
  // ── SC-A ─────────────────────────────────────────────────────
  {
    id: 'sca',
    slug: 'sca',
    name: 'D-TECH SC-A',
    model: 'SC-A',
    series: 'sca',
    badge: 'Heavy Duty',
    price: 2100,
    description:
      'Robustnija, industrijska verzija namenjena teškim uslovima rada. Stabilnija na grubim i neravnim stepenicama zahvaljujući sistemu sa dva velika zadnja pogonska točka i dodatnim podiznim zupčastim mehanizmom. Idealan za građevinske materijale, manje se haba.',
    image: 'https://cdn.magicpatterns.com/uploads/akDJq68nVZQ2xPt6hvjWBg/1.jpg',
    gallery: [
      {
        type: 'video',
        url: 'https://cdn.magicpatterns.com/uploads/mSYYNkJyukoDMZMh7e8PPt/SCA.mp4',
      },
      {
        type: 'image',
        url: 'https://cdn.magicpatterns.com/uploads/fiFTm5CkJjaa2vxi6jT12K/2.jpg',
      },
      {
        type: 'image',
        url: 'https://cdn.magicpatterns.com/uploads/cjwunoexxNR1kMK1aoVNDE/3.jpg',
      },
    ],
    specs: {
      capacity: 'do 250 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      size: '65 x 56 x 120–180 cm',
      foldingThickness: '35 cm',
      weight: '37 kg',
      leadTime: '2 meseca od potvrde porudžbine',
    },
    features: [
      'Dva velika zadnja pogonska točka za stabilnost na grubim stepenicama',
      'Dodatni podizni zupčasti mehanizam',
      'Električna kočnica za kontrolu na nagibu',
      'Beskrajna regulacija brzine',
      'Sklopiva konstrukcija',
      'Litijumska baterija (do 4h u optimalnim uslovima)',
      'Namenjen za građevinski sektor i intenzivnu upotrebu',
    ],
    highlights: [
      'Dva pogonska točka — stabilnost na grubim stepenicama',
      'Zupčasti podizni mehanizam',
      'Električna kočnica',
    ],
  },

  // ── SC-B Series ──────────────────────────────────────────────
  {
    id: 'standard',
    slug: 'standard',
    name: 'D-TECH STANDARD',
    model: 'SC-B',
    series: 'scb',
    price: 2190,
    description:
      'Osnovna konfiguracija sistema za svakodnevnu profesionalnu upotrebu. Pouzdano rešenje za transport tereta uz stepenice u građevini, logistici i uslugama dostave.',
    image:
      'https://cdn.magicpatterns.com/uploads/m5nEPzJD6tLEnedUiegTe9/basic_1.jpg',
    specs: {
      capacity: 'do 200 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (1 baterija)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      size: '65 x 56 x 120–180 cm',
      foldingThickness: '35 cm',
      weight: '37 kg',
      leadTime: '2 meseca od potvrde porudžbine',
    },
    features: [
      'Električna kočnica za kontrolu na nagibu',
      'Automatski gas sa manuelnom kontrolom (tempomat)',
      'Podesiva ručka za visinu',
      'Beskrajna regulacija brzine',
      'Industrijska mat boja',
      'Kompaktan sklopivi dizajn',
      'Brza i laka zamena baterije',
      'Litijumska baterija (do 4h u optimalnim uslovima)',
    ],
    highlights: [
      '1 baterija 48V 36Ah',
      'Industrijska mat boja',
      'Električna kočnica za kontrolu na nagibu',
    ],
  },
  {
    id: 'atlas',
    slug: 'atlas',
    name: 'D-TECH STANDARD+',
    model: 'SC-B',
    series: 'scb',
    comingSoon: true,
    price: 2290,
    description:
      'Standard konfiguracija sa dodatnim zaštitnim, neklizajućim slojem za povećanu stabilnost i otpornost u zahtevnim radnim uslovima.',
    image:
      'https://cdn.magicpatterns.com/uploads/m5nEPzJD6tLEnedUiegTe9/basic_1.jpg',
    specs: {
      capacity: 'do 200 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (1 baterija)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      size: '65 x 56 x 120–180 cm',
      foldingThickness: '35 cm',
      weight: '37 kg',
      leadTime: '2 meseca od potvrde porudžbine',
    },
    features: [
      'Zaštitni neklizajući sloj za povećanu stabilnost',
      'Električna kočnica za kontrolu na nagibu',
      'Automatski gas sa manuelnom kontrolom (tempomat)',
      'Podesiva ručka za visinu',
      'Beskrajna regulacija brzine',
      'Kompaktan sklopivi dizajn',
      'Brza i laka zamena baterije',
      'Litijumska baterija (do 4h u optimalnim uslovima)',
    ],
    highlights: [
      '1 baterija 48V 36Ah',
      'Zaštitni neklizajući sloj',
      'Električna kočnica',
    ],
  },
  {
    id: 'raptor',
    slug: 'raptor',
    name: 'D-TECH RAPTOR',
    model: 'SC-B',
    series: 'scb',
    price: 2590,
    description:
      'Premium konfiguracija sa specijalnom zaštitnom bojom otpornom na habanje i dve baterije za produženi rad bez zastoja.',
    image:
      'https://cdn.magicpatterns.com/uploads/m5nEPzJD6tLEnedUiegTe9/basic_1.jpg',
    specs: {
      capacity: 'do 200 kg',
      motor: '1200W',
      battery: '48V 36Ah litijum (2 baterije)',
      chargingTime: '4h',
      climbingSpeed: 'Beskrajna regulacija brzine',
      size: '65 x 56 x 120–180 cm',
      foldingThickness: '35 cm',
      weight: '37 kg',
      leadTime: '2 meseca od potvrde porudžbine',
    },
    features: [
      'Specijalna zaštitna boja otporna na habanje',
      'Dve litijumske baterije za produženi rad',
      'Brza i laka zamena baterije',
      'Električna kočnica za kontrolu na nagibu',
      'Automatski gas sa manuelnom kontrolom (tempomat)',
      'Podesiva ručka za visinu',
      'Beskrajna regulacija brzine',
      'Kompaktan sklopivi dizajn',
    ],
    highlights: [
      '2 baterije 48V 36Ah',
      'Boja otporna na habanje',
      'Električna kočnica',
    ],
  },

  // ── SC-C ─────────────────────────────────────────────────────
  {
    id: 'scc',
    slug: 'scc',
    name: 'D-TECH SC-C',
    model: 'SC-C',
    series: 'scc',
    badge: 'Cargo Platform',
    price: 2800,
    description:
      'Električna kolica za prevoz tereta po ravnim površinama i industrijskim objektima. Namenjena za velike težine i dug radni ciklus — do 600 kg nosivosti i 12 sati rada.',
    image:
      'https://cdn.magicpatterns.com/uploads/m5nEPzJD6tLEnedUiegTe9/basic_1.jpg',
    specs: {
      capacity: 'do 600 kg',
      motor: '1200W',
      battery: '48V litijum',
      chargingTime: 'Na upit',
      climbingSpeed: 'Nije primenjivo (ravne površine)',
      size: '100 x 60 x 102 cm',
      foldingThickness: 'Nije sklopiva',
      weight: '60 kg',
      leadTime: '2 meseca od potvrde porudžbine',
    },
    features: [
      'Nosivost do 600 kg',
      'Pneumatski točkovi za glatko kretanje',
      'Do 12 sati rada na jednom punjenju',
      'Električni pogon 1200W',
      'Litijumska baterija 48V',
      'Namenjen za magacine, fabrike i distributivne centre',
    ],
    highlights: [
      'Nosivost do 600 kg',
      'Do 12h rada na bateriji',
      'Pneumatski točkovi',
    ],
  },
]

export const scbProducts = products.filter((p) => p.series === 'scb')
export const otherProducts = products.filter((p) => p.series !== 'scb')

export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug)
}
